import React, { useState, useEffect } from 'react'
import styleInput from './Input.module.scss'
import { InputProps } from './Input'

interface IInputViewProps extends InputProps {
  setIsFocus: (isFocus: boolean) => void
  classNameValueFocus: (
    value: string | number,
    isFocus: boolean,
    isFixed: boolean
  ) => string
  changeInput: (event: React.ChangeEvent<HTMLInputElement>) => void
  isChecked: boolean | false
  isMultiple: boolean | false
}

export type InputViewProps = IInputViewProps

export const useInput = (props: InputProps): InputViewProps => {
  const [value, setValue] = useState(props.value)
  const [label, setLabel] = useState(props.label)
  const [isFixed, setIsFixed] = useState(props.isFixed)
  const [type, setType] = useState(props.type)
  const [reference, setReference] = useState(props.reference)
  const [disabled, setDisabled] = useState(props.disabled)
  const [isFocus, setIsFocus] = useState(props.isFocus)
  const [isDashed, setIsDashed] = useState(props.isDashed)
  const [isChecked, setIsChecked] = useState(props.isChecked)
  const [isMultiple, setIsMultiple] = useState(props.isMultiple)

  useEffect(() => {
    return () => {
      setValue(null)
      setLabel(null)
      setIsFixed(false)
      setType('text')
      setReference(null)
      setDisabled(false)
      setIsFocus(false)
      setIsDashed(false)
      setIsChecked(false)
      setIsMultiple(false)
    }
  }, [])

  useEffect(() => {
    setValue(props.value)
    setLabel(props.label)
    setIsFixed(props.isFixed)
    setType(props.type)
    setReference(props.reference)
    setDisabled(props.disabled)
    setIsFocus(props.isFocus)
    setIsDashed(props.isDashed)
    setIsChecked(props.isChecked)
    setIsMultiple(props.isMultiple)
  }, [
    props.value,
    props.label,
    props.isFixed,
    props.type,
    props.reference,
    props.disabled,
    props.isFocus,
    props.isDashed,
    props.isChecked,
    props.isMultiple
  ])

  const classNameValueFocus = (
    value: string | number | null,
    isFocus: boolean,
    isFixed: boolean
  ): string | null => {
    if (isFocus) {
      return styleInput._field__box_value + ' ' + styleInput._field__box_focused
    } else if (isFixed) {
      return styleInput._field__box_value
    } else if (value) {
      return styleInput._field__box_value
    }

    return null
  }

  const changeInput = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setValue(event.target.value || null)
    if (props.onChange) {
      props.onChange(event)
    }
  }

  return {
    value,
    label,
    isFixed,
    type,
    reference,
    disabled,
    isFocus,
    setIsFocus,
    isDashed,
    classNameValueFocus,
    changeInput,
    isChecked,
    isMultiple,
    maxNumber: props.maxNumber,
    minNumber: props.minNumber,
    stepNumber: props.stepNumber
  }
}
